import React from 'react';
import { Route, Routes } from 'react-router';
import { DashboardList } from './DashboardList';
import { EditDashboard } from './EditDashboard';
import { NewDashboard } from './NewDashboard';
export const DashboardPanel = ({ hideHeader }) => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: '', element: React.createElement(DashboardList, { hideHeader: hideHeader }) }),
        React.createElement(Route, { path: '/new/*', element: React.createElement(NewDashboard, null) }),
        React.createElement(Route, { path: '/:dashboardId/*', element: React.createElement(EditDashboard, null) })));
};
